var map = {
	"./basketball.webp": 1678,
	"./bti-img.webp": 1679,
	"./bti-title-cn.webp": 1680,
	"./bti-title-en.webp": 1681,
	"./cup.webp": 1682,
	"./football.webp": 1683,
	"./im-img.webp": 1684,
	"./im-title-cn.webp": 1685,
	"./im-title-en.webp": 1686,
	"./sb-img.webp": 1687,
	"./sb-title-cn.webp": 1688,
	"./sb-title-en.webp": 1689,
	"./sbo-img.webp": 1690,
	"./sbo-title-cn.webp": 1691,
	"./sbo-title-en.webp": 1692,
	"./sport-bg.webp": 1693,
	"./sport-ctg.webp": 1694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 781;